import { render, staticRenderFns } from "./Giros.vue?vue&type=template&id=50ef07ad"
import script from "./Giros.vue?vue&type=script&lang=js"
export * from "./Giros.vue?vue&type=script&lang=js"
import style0 from "./Giros.vue?vue&type=style&index=0&id=50ef07ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports